import { BaseParkingFacilityDetailContent } from '@/components/map/details/content/BaseParkingFacilityDetailContent';
import type { ParkingFacility, ParkingFacilityData } from '@/modules/api/backend';

interface ParkingFacilityDetailContentProps {
  facility: ParkingFacility;
  data?: ParkingFacilityData;
}

export function ParkingFacilityDetailContent({ facility, data }: ParkingFacilityDetailContentProps) {
  return <BaseParkingFacilityDetailContent data={data} facility={facility} />;
}
